export * from "ce/pages/common/ConvertEntityNotification";
import { default as CE_ConvertToModuleInstanceCTA } from "ce/pages/common/ConvertEntityNotification";
export default CE_ConvertToModuleInstanceCTA;
